import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { SettingModel } from '../Settings';

interface SettingsTableProps {
  settings: SettingModel[];
  onEditSetting: (settingKey: string) => void;
}

const SettingsTable: React.FC<SettingsTableProps> = ({ settings, onEditSetting }) => {
  return (
    <div className="flex flex-col">
      <div className="w-full overflow-auto">
        <table className="min-w-full border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="text-left py-2 px-4 border-b">Setting Title</th>
              <th className="text-left py-2 px-4 border-b">Setting Value</th>
              <th className="text-left py-2 px-4 border-b"></th>
            </tr>
          </thead>
          <tbody>
            {settings && settings.length > 0 ? (
              settings.map((setting, index) => {
                let value = '';
                if (
                  setting.settingValueList &&
                  (setting.settingValueList?.length || 0) > 0 &&
                  typeof setting.settingValueList[0] === 'object'
                ) {
                  const selectValueIndex = (setting.settingValueList || [])?.findIndex(
                    (item) => (typeof item === 'string' ? item : item?.value) === setting.settingValue,
                  );
                  const selectValue = setting.settingValueList[selectValueIndex];
                  if (selectValue && typeof selectValue !== 'string') {
                    value = selectValue.title;
                  } else {
                    value = setting.settingValue?.toString();
                  }
                } else {
                  value = setting.settingValue?.toString();
                }
                return (
                  <tr key={setting.id || index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                    <td className="text-left py-2 px-4 border-b">{setting.settingTitle}</td>
                    <td className="text-left py-2 px-4 border-b">{value}</td>
                    <td className="text-left py-4 px-4 border-b flex gap-5">
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="cursor-pointer"
                        title="Edit Setting"
                        onClick={() => onEditSetting(setting.id)}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className="text-center py-4 px-4">
                  No settings available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SettingsTable;
